import React from 'react';
import { InputItem } from '@beisen/chaos-ui';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
    inputHolder: '点击填写',
    required: '必填',
    searchInputHolder: '点击输入',
    confirm: '确定',
    clear: '清空'
};
class Url extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            inputValue: this.props.text
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            inputHolder: 'fieldPlaceHolder.inputHolder',
            required: 'common.required',
            searchInputHolder: 'fieldPlaceHolder.searchInputHolder',
            confirm: 'common.confirm',
            clear: 'common.clear'
        }), props.translation);
    }

    handleClearValue() {
        this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.setState({ inputValue: '' });
        if(this.props.onBlur) {
            this.props.onBlur({ text: '',value: '' });
        }
        this.props.synBizData && this.props.synBizData();
    }

    isReadOnly() {
        this.props.cmp_data.cmp_status == 'readonly' || this.props.cmp_data.cmp_status == 'default';
    }

    handleChange(e) {
        this.setState({ inputValue: e.target.value });
    }

    handleBlur(e) {
        let text = this.state.inputValue.trim();
        let value = text;
        this.setState({ inputValue: value });
        if(this.props.onBlur) {
            this.props.onBlur({ text, value });
        }
    }

    handleSubmit() {
        this.props.handleCancel && this.props.handleCancel();
        this.props.synBizData && this.props.synBizData();
    }

    shouldComponentUpdate(nextprops, nextState) {
        if(nextprops.value != this.props.value ||
            nextprops.text != this.props.text ||
            JSON.stringify(nextState) != JSON.stringify(this.state) ||
            JSON.stringify(nextprops.errorMessage) != JSON.stringify(this.props.errorMessage) ||
            !Immutable.is(Immutable.fromJS(this.props.cmpData),Immutable.fromJS(nextprops.cmpData))
          ) {
            return true;
        }
        return false;
    }

    componentWillReceiveProps(nextProps) {
        //if(nextProps.hasOwnProperty('text') && nextProps.text != this.props.text || nextProps.value != this.props.value) {
            this.setState({ inputValue: nextProps.text });
        //}
    }

    render() {
       const { desc, errorMessage, ...other } = this.props;
       const errMsg = errorMessage && errorMessage.message;
       return (
        <InputItem
            {...other}
            value={this.state.inputValue}
            type="url"
            label={this.props.label}
            stateClass={this.props.stateClass}
            isReadOnly={this.props.isReadOnly}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorMsg={errMsg}
            desc={desc}
            placeholder={this.props.formType === 'searchForm' ?  this.props.cmp_data.promptmessage : undefined}
            popType={this.props.pop_type}
            onSubmit={this.handleSubmit}
            onClearValue={this.handleClearValue}
            translation={this.translation}
        />);
    }
}

Url.defaultProps = {
    cmp_data: {}
};
export default Url;



// WEBPACK FOOTER //
// ./src/components/Field_Components/Url/Url.js